export default __webpack_public_path__ + "static/media/kausi11-min.bfc6b8dd.jpg";